import { Suspense } from "react";

interface Props {
  children: JSX.Element;
}

export const SuspenseWithFallback = ({ children }: Props): JSX.Element => {
  return <Suspense>{children}</Suspense>;
};
